app.controller('homeController', function($http, $scope, $stateParams, $location, dataService, DTColumnBuilder, pageConfig, pageHandler, $timeout, $controller, $modal,$rootScope) {

	//Include custom controller functionality
	$controller('userDefinedHomeController', {$scope: $scope, $stateParams: $stateParams});
	
	//initialise survey specific views
	pageHandler.initViews(pageConfig, $scope);

	//initialise filters
	var filtersLoaded = pageHandler.initFilters(pageConfig, $scope);
	
	if(filtersLoaded)
	{	
		//initialise components
		pageHandler.initComponents(pageConfig, $scope);
	
		//show loading on components
		pageHandler.showLoading(pageConfig, $scope);
	
		//request data for components
		pageHandler.requestDataForComponents(pageConfig, $scope);
		
		//initialize export feature
		pageHandler.initPageExports(pageConfig, $scope);
	}


//POPUP used for BBQ BG008-2
if(pageConfig.hasOwnProperty('html_options')){

	angular.forEach(pageConfig.html_options, function(params, model_popup_type) {

  			switch (model_popup_type) {

                case 'nps_model_popup':

                    	if(pageConfig.components.hasOwnProperty(params.component_name) && $rootScope.hasOwnProperty('can_access_nps_popup_notification') && $rootScope.can_access_nps_popup_notification == 'yes')
						 {
						 	var popup_count_track_name = 'popup_count_'+params.component_name+'_'+$rootScope.appState.admin_site_superset_value+'_'+$rootScope.appState.submit_time_value;
							$rootScope[popup_count_track_name] = ($rootScope.hasOwnProperty(popup_count_track_name))? $rootScope[popup_count_track_name]+1 : 0;
						 	
						 	var dispay_popup_count = $rootScope[popup_count_track_name];
						 	$scope.$watch(params.nps_score_from, function(nps_score) {

						 				if(nps_score !== undefined && nps_score.hasOwnProperty('value'))
						 				{
						 					var nps_metics_score =  parseFloat(nps_score.value);
						 					$scope.message = '';
						 					$scope.text_color = '';
						 					if(nps_metics_score >= parseFloat(params.nps_target) )
						 					{
						 						$scope.message = params.message[params.nps_target]['text'];
						 						$scope.text_color = params.message[params.nps_target]['text-color'];
						 					}
						 					else if(nps_metics_score >= parseFloat(params.nps_close_to_target) && nps_metics_score < parseFloat(params.nps_target))
						 					{
						 						$scope.message = params.message[params.nps_close_to_target]['text'];
						 						$scope.text_color = params.message[params.nps_close_to_target]['text-color'];
						 					}

						 					if(params.dispay == 0 && $scope.message != '')
									 		{
												var modalInstance = $modal.open({
											        templateUrl: 'views\/nps_notifications.html',
											        controller: cancelCtrl,
											        scope : $scope,
											        windowClass : 'upload_form_window'
											    });
									 			
									 		}
									 		else if(dispay_popup_count < params.dispay && $scope.message != '')
									 		{
									 			var modalInstance = $modal.open({
											        templateUrl: 'views\/nps_notifications.html',
											        controller: cancelCtrl,
											        scope : $scope,
											        windowClass : 'upload_form_window'
											    });
									 		}
						 				}
						 	});	 	
						 }
                    break;
                   }
	});
}
	
    //Controller for cancel action dialog
	function cancelCtrl($http, $q, $scope, $modalInstance, $modal, $timeout) {

		$scope.cancel = function() {
	        $modalInstance.dismiss('cancel');
	    };

	}
	
});
